import { passiveOption } from './passiveOption.js';

export function addEvents(el, obj, preventScrolling) {
  for (var prop in obj) {
    var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 && !preventScrolling ? passiveOption : false;
    el.addEventListener(prop, obj[prop], option);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/addEvents.js
// module id = 95
// module chunks = 0